import { useMemo } from 'react'
import { useActiveBuildings } from '../use-active-buildings/use-active-buildings'

export const useActiveBuildingsIds = () => {
  const { activeBuildings, isFetching, error } = useActiveBuildings()
  const buildingIds = useMemo(() => activeBuildings.map((building) => building.id), [activeBuildings])

  return { buildingIds, isFetching, error }
}
